import { render } from "./RegionsEditorView.vue?vue&type=template&id=24e8914c&scoped=true"
import script from "./RegionsEditorView.vue?vue&type=script&lang=js"
export * from "./RegionsEditorView.vue?vue&type=script&lang=js"

import "./RegionsEditorView.vue?vue&type=style&index=0&id=24e8914c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e8914c"]])

export default __exports__